const ky = require('ky/umd').default
const valvelet = require('valvelet')
const DBBQ = require('debouncing-batch-queue')

const throttledLogSender = ({
  appLogger,
  requestLimit = 1,
  requestInterval = 1000,
  logsPerBatch = 10,
  batchDrainTimeout = 500
}) => {
  const sendRequest = logs => {
    ky
      .post('https://frog.wix.com/wct', { json: logs })
      .catch(e => appLogger.warn(e))
    // TODO:  break down logs in case of network issue?
  }

  const batchedLogsQueue = new DBBQ(batchDrainTimeout, logsPerBatch)
  const sendLogThrottled = log => batchedLogsQueue.add(log)

  const throttledSendRequest = valvelet(
    sendRequest,
    requestLimit,
    requestInterval,
    10000 // queue size
  )
  batchedLogsQueue.on('data', logs => throttledSendRequest(logs))

  return {
    sendLogThrottled
  }
}

module.exports.throttledLogSender = throttledLogSender
